import { Fragment } from "react";
import { Vector3 } from "three";
import { match } from "ts-pattern";
import { useCabinetStore } from "../../../../context/StoreContext";
import { materialsSku } from "../../../../library/utilities";
import { getCurrentThickness } from "../../data";

export default function Lights() {
	const { state, api } = useCabinetStore();
	const thickness = getCurrentThickness(state, api);

	const lights = {
		directionalLight: {
			intensity: 0.75 * Math.PI,
			position: new Vector3(state.width / 1000 / 2, state.height / 1000, 50),
		},
		spotLightFront: {
			intensity: 10,
			position: new Vector3(
				state.width / 1000 / 2,
				(state.height / 1000) * 1.25,
				state.width / 1000 / 0.8,
			),
		},
		spotLightLeft: {
			intensity: 10,
			position: new Vector3(-2, state.height / 1000 + 0.5, 1.5),
		},
		spotLightRight: {
			intensity: 10,
			position: new Vector3(state.width / 1000 + 2, state.height / 1000 + 0.5, 1.5),
		},
		spotLightTop: {
			intensity: 0,
			position: new Vector3(state.width / 1000 / 2, state.height / 1000 + 2, 0.5),
		},
	};

	match(thickness?.sku).with(...materialsSku.black, () => {
		lights.directionalLight.intensity = 1.5;

		// front
		lights.spotLightFront = {
			position: new Vector3(
				state.width / 1000 / 2,
				(state.height / 1000) * 1.25,
				state.width / 1000 / 0.8,
			),
			intensity: 30,
		};

		// left
		lights.spotLightLeft.position = new Vector3(-2, state.height / 1000 / 2, 1.5);
		lights.spotLightLeft.intensity = 30;

		// right
		lights.spotLightRight.position = new Vector3(
			state.width / 1000 + 2,
			state.height / 1000 / 2,
			1.5,
		);
		lights.spotLightRight.intensity = 30;

		// top
		lights.spotLightTop.intensity = 30;
		lights.spotLightTop.position = new Vector3(
			state.width / 1000 / 2,
			state.height / 1000 + 2,
			1.5,
		);
	});

	return (
		<Fragment>
			<ambientLight intensity={0.8 * Math.PI} />
			<directionalLight
				position={lights.directionalLight.position}
				intensity={lights.directionalLight.intensity}
				castShadow
			/>

			{/* front */}
			<spotLight
				position={lights.spotLightFront.position}
				intensity={lights.spotLightFront.intensity}
			/>

			{/* left */}
			<spotLight
				position={lights.spotLightLeft.position}
				intensity={lights.spotLightLeft.intensity}
				castShadow
			/>

			{/* right */}
			<spotLight
				position={lights.spotLightRight.position}
				intensity={lights.spotLightLeft.intensity}
				castShadow
			/>
			{/* top */}
			<spotLight
				position={lights.spotLightTop.position}
				intensity={lights.spotLightTop.intensity}
				castShadow
			/>
		</Fragment>
	);
}
